import {memo} from "react";
import {TreeNode} from "@/types";
import {get_color} from "@/pages/mindmap/CarNodes/BasicCardNode.tsx";
import {formatCompactNumber, formatPercentage} from "@/utils/format.ts";


export const CategoryProvienceNode = ({node}: {node:TreeNode}) => {

    const datas = node.metrics_map || {}

    const get_child_gap = (provience:string) => {
        const child = node.children?.find(c => c.name == provience)
        const datas = child?.metrics_map || {}
        return <div>
            <span>{provience}:&nbsp;</span>
            {(datas["ims_amt_mtd_gap"]?.value ?? 0) < 0 ?
                <span style={get_color("ims_amt_mtd_gap", datas)}>
                    {formatCompactNumber((datas["ims_amt_mtd_gap"]?.value ?? 0))}
            </span>:
                <>--</>
            }
        </div>
    }

    const render_common_grid = (
        column_cfgs: { label: string, label2: string, col1_key: string, col2_key: string }[]
    ) => {
        const ContributionRow = ({label, label2, col1_key, col2_key}: {
            label: string,
            label2: string,
            col1_key: string,
            col2_key: string,
        }) => (
            <>
                <div>
                    <span>{label}: </span>
                    <span style={get_color(col1_key, datas)}>
                            {formatPercentage(datas[col1_key]?.value)}
                        </span>
                </div>
                {get_child_gap(label2)}
            </>
        );
        return <div style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '2px 12px',
            marginBottom: '2px',
            color: 'rgb(71, 85, 105)'
        }}>
            <div style={{fontWeight: 700, color: 'rgb(30, 41, 59)'}}>IMS Contribution (MTD)</div>
            <div style={{fontWeight: 700, color: 'rgb(30, 41, 59)'}}>Top 3 IMS Gap (MTD)</div>
            {
                column_cfgs.map((cfg, index) => (
                    <ContributionRow
                        key={"cr-" + index}
                        label={cfg.label}
                        label2={cfg.label2}
                        col1_key={cfg.col1_key}
                        col2_key={cfg.col2_key}
                    />
                ))
            }
        </div>
    }


    const params = ["1", "2", "3"].map((rank) => ({
        label: datas[`province_amt_rk${rank}`].display,
        label2: datas[`province_gap_rk${rank}`].display,
        col1_key: `province_amt_rk${rank}_pct`,
        col2_key: `province_gap_rk${rank}_pct`
    }))
    return <div style={{marginLeft: '10px'}}>
        {render_common_grid(params)}
    </div>

};